import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import ErrorPage from '../views/ErrorPage'
import Loading from '../views/Loading'
import Answer from '../views/Answer'
import Thank from '../views/Thank'
import Expired from '../views/Expired'
import Fulled from '../views/Fulled'
import Private from '../views/Private'

Vue.use(VueRouter)

const routes = [
  { path: '/loading', name: 'Loading', component: Loading },
  { path: '/errorPage', name: 'ErrorPage', component: ErrorPage },
  { path: '/answer', name: 'Answer', component: Answer },
  { path: '/thank', name: 'Thank', component: Thank },
  { path: '/expired', name: 'Expired', component: Expired },
  { path: '/private', name: 'Private', component: Private },
  { path: '/fulled', name: 'Fulled', component: Fulled }
]

let zhConfig = require('../../zh.config')
const isIISSubApp = zhConfig.isIISSubApp
const IISSubAppRoute = zhConfig.IISSubAppRoute
const base =
  process.env.NODE_ENV === 'production'
    ? isIISSubApp
      ? '/' + IISSubAppRoute + '/user'
      : '/user'
    : '/'

const router = new VueRouter({
  mode: 'history',
  base,
  routes
})

router.beforeEach((to, from, next) => {
  let finished = store.state.finished
  // 已完成的問卷只允許出現 Thank 頁面
  if (to.name !== 'Thank' && finished) {
    next({ name: 'Thank' })
  } else {
    next()
    window.console.log(to)
  }
})
export default router
